import { BorrowerLendingLimitTableType } from '../../BorrowerLendingLimitTableType';
import { getInfoBubble } from '../../../helpers/getInfoBubble';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { formatTooltip } from '../../../../formatters/formatToolTip';

export enum SummaryItemStyleMode {
    Bold = 'Bold',
    Italic = 'Italic',
    Regular = 'Regular',
}

export const summaryItemTypeCellRender = (
    e,
    tableType: BorrowerLendingLimitTableType,
    columnType: string,
    styleMode: SummaryItemStyleMode = SummaryItemStyleMode.Bold
) => {
    const infoBubbleText = getInfoBubble(tableType, columnType, e.value);
    const showHelper = Boolean(infoBubbleText);
    const tooltipId = `summaryItemHelper_${e.rowIndex}_${e.columnIndex}`;

    const baseStyle = (() => {
        switch (styleMode) {
            case SummaryItemStyleMode.Italic:
                return {
                    fontStyle: 'italic',
                    fontWeight: 400,
                    color: 'black',
                };

            case SummaryItemStyleMode.Regular:
                return {
                    fontStyle: 'normal',
                    fontWeight: 400,
                    color: 'black',
                };

            case SummaryItemStyleMode.Bold:
            default:
                return {
                    fontStyle: 'normal',
                    fontWeight: 700,
                    color: 'black',
                };
        }
    })();

    return (
        <>
            <span style={baseStyle}>{e.value}</span>{' '}
            {showHelper && (
                <>
                    <span
                        className='helper'
                        data-tip
                        data-for={tooltipId}
                        style={{ marginLeft: '5px' }}
                    >
                        <span className='tooltip-trigger'>
                            <FontAwesomeIcon icon={faInfoCircle} />
                        </span>
                    </span>

                    {formatTooltip(tooltipId, infoBubbleText)}
                </>
            )}
        </>
    );
};
